var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house-chimney-blank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3333 10.0135C18.3333 9.88333 18.2802 9.75405 18.1761 9.6613L16.4779 8.13892C16.4779 8.14167 16.4779 8.13617 16.4779 8.13892L16.4786 3.90959C16.4786 3.65002 16.2712 3.46641 16.041 3.46641L13.2849 3.46662C13.0286 3.46662 12.8473 3.67665 12.8473 3.90981L12.769 4.82942L10.2935 2.61731C10.2061 2.53936 10.0965 2.5 9.98691 2.5C9.87734 2.5 9.76773 2.53936 9.6803 2.61731L1.82377 9.6613C1.71967 9.75522 1.66663 9.88436 1.66663 10.0135C1.66663 10.2754 1.87647 10.4828 2.13176 10.4828C2.24067 10.4828 2.34973 10.4443 2.43693 10.3656L3.52138 9.39648L3.52153 15.1784C3.52153 16.4733 4.56164 17.5 5.81389 17.5H14.1342C15.4125 17.5 16.4265 16.4472 16.4265 15.1784L16.4266 9.39648L17.5885 10.3657C17.6763 10.4446 17.7859 10.4567 17.8951 10.4567C18.1478 10.4567 18.3333 10.2747 18.3333 10.0135ZM13.6964 4.37831H15.5251V7.31624L13.6964 5.65885V4.37831ZM15.5512 8.6047V15.1527C15.5512 15.9296 14.9272 16.5351 14.1862 16.5351H5.8398C5.07269 16.5351 4.47482 15.9032 4.47482 15.1527V8.6047C4.47482 8.59364 4.46933 8.58441 4.4686 8.57353L10.013 3.59584L15.583 8.57359C15.583 8.58416 15.5512 8.59296 15.5512 8.6047Z",
    fill: "#6A6B6D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5350d8ce8eda4fa2bb69f73a856024e2.svg";
export { ForwardRef as ReactComponent };